exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.newsweekly .center-box[data-v-62bc1d91] {\n  margin: auto;\n  float: none;\n}\n.newsweekly th[data-v-62bc1d91],\n.newsweekly td[data-v-62bc1d91] {\n  padding-left: 2em;\n  padding-right: 2em;\n}\n.newsweekly .td-right[data-v-62bc1d91] {\n  text-align: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-62bc1d91","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/DinNewsWeekly.vue
// module id = 377
// module chunks = 1